import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Form } from '../components';

export default HyperdbForm(Form, {
  namespace: 'customer',
  mountedUrl: '/daily-rental/customers',
  titleNew: 'Create new customer',
  titleEdit: 'Edit customer',
  displayName: (object) => object.name,
  checkIsValid: (props) => {
    const entity = props.objectData.entity_data;
    if (!entity) return false;
    const address = entity.primary_address;
    if (!address) return false;
    const hasCountry = address.country && address.country.value[1];
    return !!props.objectData.language && !!entity.first_name && !!entity.last_name && !!entity.primary_email && hasCountry;
  },
  onSubmit: (props) => {
    const objectData = props.objectData;
    const id = props.params.id;
    props.api.customer.submitCustomer({ objectData, id });
  }
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/customer/containers/Form.jsx